export enum ModalType {
  PREVIEW_FILE = "PREVIEW_FILE",
  MORE_INFO_FILE = "MORE_INFO_FILE",
}
